import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiX, FiVideo, FiEye, FiHeart, FiTrendingUp, FiUser } from 'react-icons/fi';
import './SpeakerDashboard.css';

const SpeakerDashboard = ({ speaker, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, [speaker.id]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/speakers/${speaker.id}/dashboard/`);
      setData(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки данных');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="speaker-dashboard-overlay">
        <div className="speaker-dashboard-modal">
          <div className="loading"><div className="spinner"></div></div>
        </div>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div className="speaker-dashboard-overlay">
      <div className="speaker-dashboard-modal">
        <div className="dashboard-header">
          <div className="dashboard-title-section">
            <div className="dashboard-avatar-ring">
              <div className="dashboard-avatar-inner">
                {data.speaker.photo ? (
                  <img
                    src={data.speaker.photo}
                    alt={data.speaker.full_name}
                    className="dashboard-speaker-photo"
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <div className="dashboard-photo-placeholder" aria-hidden>
                    <FiUser />
                  </div>
                )}
              </div>
            </div>
            <div>
              <h2>{data.speaker.full_name}</h2>
              <p className="speaker-credentials">{data.speaker.credentials}</p>
            </div>
          </div>
          <button className="dashboard-close" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <div className="dashboard-content">
          {/* Общая статистика */}
          <div className="dashboard-stats-grid">
            <div className="dashboard-stat-card">
              <div className="stat-icon">
                <FiVideo />
              </div>
              <div className="stat-info">
                <h3>{data.stats.total_webinars}</h3>
                <p>Всего вебинаров</p>
              </div>
            </div>
            <div className="dashboard-stat-card">
              <div className="stat-icon">
                <FiEye />
              </div>
              <div className="stat-info">
                <h3>{data.stats.total_views}</h3>
                <p>Просмотров</p>
              </div>
            </div>
            <div className="dashboard-stat-card">
              <div className="stat-icon">
                <FiHeart />
              </div>
              <div className="stat-info">
                <h3>{data.stats.total_likes}</h3>
                <p>Лайков</p>
              </div>
            </div>
          </div>

          {/* Самый популярный вебинар */}
          {data.popular_webinar && (
            <div className="dashboard-section">
              <h3 className="section-title">
                <FiTrendingUp /> Самый популярный вебинар
              </h3>
              <Link to={`/webinars/${data.popular_webinar.id}`} className="popular-webinar-card">
                <h4>{data.popular_webinar.title}</h4>
                <div className="popular-webinar-stats">
                  <span><FiEye /> {data.popular_webinar.views_count} просмотров</span>
                  <span><FiHeart /> {data.popular_webinar.likes_count} лайков</span>
                </div>
                <p className="popular-webinar-date">
                  {new Date(data.popular_webinar.recording_date).toLocaleDateString('ru-RU')}
                </p>
              </Link>
            </div>
          )}

          {/* Статистика по препаратам */}
          {data.medications && data.medications.length > 0 && (
            <div className="dashboard-section">
              <h3 className="section-title">Вебинары по препаратам</h3>
              <div className="medications-grid">
                {data.medications.map((med, idx) => (
                  <div key={idx} className="medication-card">
                    <h4>{med.name}</h4>
                    <p className="medication-count">{med.count} вебинаров</p>
                    <div className="medication-webinars">
                      {med.webinars.slice(0, 3).map((w) => (
                        <Link key={w.id} to={`/webinars/${w.id}`} className="medication-webinar-link">
                          {w.title}
                        </Link>
                      ))}
                      {med.webinars.length > 3 && (
                        <p className="medication-more">+{med.webinars.length - 3} еще</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Список всех вебинаров */}
          <div className="dashboard-section">
            <h3 className="section-title">Все вебинары ({data.webinars.length})</h3>
            <div className="webinars-list">
              {data.webinars.map((webinar) => (
                <Link key={webinar.id} to={`/webinars/${webinar.id}`} className="webinar-list-item">
                  <div className="webinar-list-content">
                    <h4>{webinar.title}</h4>
                    <div className="webinar-list-meta">
                      <span>{new Date(webinar.recording_date).toLocaleDateString('ru-RU')}</span>
                      <span><FiEye /> {webinar.views_count}</span>
                      <span><FiHeart /> {webinar.likes_count}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerDashboard;
